import React, { useState, useRef, useMemo, useEffect } from 'react'
import { Popover, message } from 'antd'
import Icon from 'meinian-package/src/component/icon'
import { BatchStart, BatchAll, BatchNum, BatchStop, BatchItem, BatchOptions } from 'component'
import MNWaterfallApi from 'component/waterfall/masonryApi'
import Marking from 'image/workbench/marking.png'
import { request, message as mes } from 'meinian-package/src/utils'
import moment from 'moment'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import { UPLOAD_ERROR_TYPE } from 'meinian-package/src/component/upload'
import Button from 'meinian-package/src/baseComponent/button'
import classNames from 'classnames'
import ImageDetail from 'view/detail/imageDetail'
import Upload, { Action } from './common'
import getBoxLabelRetList from '../../common/getBoxLabelRetList'
import emptyJson from './emptyData.json'
import RecordInfoCard from '../../components/recordInfoCard'
import CustomizeHeader, { CustomizeHeaderLeftDefault } from '../../components/header/customizeHeader'
import FeedbackModal from '../../components/feedbackModal'
import InfoModal from '../../components/feedbackModal/infoModal'
import styles from './index.module.less'

export default () => {
  const [isBatch, setIsBatch] = useState(false)
  const [batchAll, setBatchAll] = useState([])
  const waterfallRef = useRef()
  const [limit, setLimit] = useState({
    limit: 0,
    todayCount: 0,
  })

  const beforeUpload = (file) => {
    if (file.length > 20) {
      message.error('一次仅支持同时上传20张图片，请分批上传')
      return false
    }
    return true
  }

  const afterUpload = (file) => {
    const images = []
    file.forEach((item) => {
      images.push({ picUrl: item.url, source: 1 })
    })
    if (!images.length) {
      return
    }
    request.post('/zhikuan/intelligence-tag/recognize', { images }).then((success) => {
      if (success) {
        message.success('上传图片成功')
        waterfallRef.current?.init()
      }
    })
  }

  const onDeleteAll = (val) => {
    ModalConfirm.show({
      title: '确认删除',
      content: '是否删除当前识别记录？',
      onOk: async () => {
        request.post('/zhikuan/intelligence-tag/delete', { unionIdList: [...val] }).then(success => {
          if (success) {
            message.success('删除成功')
            setIsBatch(false)
            waterfallRef.current?.init()
          }
        })
      },
    })
  }

  const fetchData = () => {
    request.get('/zhikuan/intelligence-tag/limit').then((res) => {
      setLimit(res)
    })
  }
  const [alertVisible, setAlertVisible] = useState(+localStorage.getItem('mn-marking-header-content-visible'))
  useEffect(() => {
    if (!localStorage.getItem('mn-marking-header-content-visible')) {
      localStorage.setItem('mn-marking-header-content-visible', '1')
      setAlertVisible(1)
    }
  }, [])
  const onClose = () => {
    localStorage.setItem('mn-marking-header-content-visible', '0')
    setAlertVisible(0)
  }

  const [feedbackModalVisible, setFeedbackModalVisible] = useState(false)
  const [infoModalVisible, setInfoModalVisible] = useState(false)
  const [feedbackModalData, setFeedbackModalData] = useState({})
  const infoModalRef = useRef(null)

  useEffect(() => {
    const subUploadImage = () => {
      waterfallRef.current?.init()
    }
    mes.sub('onMNUploadImage', subUploadImage)
    return () => {
      mes.remove('onMNUploadImage', subUploadImage)
    }
  }, [])

  const onFeedback = (_data) => {
    setFeedbackModalData(_data)
    setFeedbackModalVisible(true)
  }
  const onFeedbackModalOk = async (params) => {
    request.post('/zhikuan/intelligence-tag/feedback', params).then(success => {
      if (success) {
        setFeedbackModalVisible(false)
        setInfoModalVisible(true)
        setTimeout(() => {
          infoModalRef.current?.onOk()
        })
        return true
      }
    })
    return false
  }
  const onError = (val) => {
    if (UPLOAD_ERROR_TYPE.SIZE_ERROR === val) {
      message.error('上传图片超过10M')
    }
  }
  return <div>
    <CustomizeHeader
      hiddenSearch
      renderLeft={() => <CustomizeHeaderLeftDefault
        paths={[{
          name: '工作台',
          path: '/home/workbench/index'
        }, {
          name: '智能打标',
          path: null,
        }]}
      />}
    />
    <div className={styles['mn-marking']}>
      <div className="mn-marking-header">
        <Upload afterUpload={afterUpload} multiple beforeUpload={beforeUpload} onError={onError}>
          <Button type="primary" className="mn-marking-upload-image-btn">
            <Icon type="m-shangchuan" className="mn-marking-upload-image-btn-icon" />
            <span style={{ marginLeft: '8px' }}>上传图片</span>
          </Button>
        </Upload>
      </div>
      {
      !!alertVisible && <div className="mn-marking-header-content">
        <div className="mn-marking-header-content-left">
          <div className="mn-marking-header-content-left-line-1">智能打标</div>
          <div className="mn-marking-header-content-left-line-2">上传服饰图片，系统自动识别服饰的品类、颜色、风格、工艺等信息，支持批量上传图片识别</div>
          <Upload afterUpload={afterUpload} multiple beforeUpload={beforeUpload} onError={onError}>
            <div className="mn-marking-header-content-left-line-3">
              上传图片 <Icon type="m-Vxing_you" />
            </div>
          </Upload>
        </div>
        <div className="mn-marking-header-content-right">
          <img src={Marking} />
        </div>
        <div className="mn-marking-header-content-close" onClick={onClose}><Icon type="m-guanbi_tianchong" /></div>
      </div>
    }
      <div className="mn-marking-list">
        <div style={{ paddingBottom: '16px' }}>
          <div className="mn-marking-list-header">
            <div className="mn-marking-list-header-title">识别记录</div>
            <div className="mn-marking-list-header-title-right">
              {!!batchAll.length && !isBatch && <BatchStart onClick={() => setIsBatch(true)} />}
              <div style={{ marginLeft: '16px' }}>今天识别额度<span>{limit.todayCount}/{limit.limit === -1 ? '不限' : limit.limit}</span></div>
            </div>
          </div>
          {
        isBatch && <div className="batch-operation">
          <div className="meinian-space" />
          <BatchAll style={{ marginRight: 16 }} keyValues={batchAll?.map(i => i.unionId)} infos={batchAll} />
          <BatchNum style={{ marginRight: 40 }} />
          <BatchOptions.DeleteItem onChange={onDeleteAll} />
          <BatchStop onClick={() => setIsBatch(false)} />
        </div>
      }
        </div>
        <div className="mn-marking-list-content-wrapper">
          <MNWaterfallApi
            renderItem={Card}
            ref={waterfallRef}
            gutter={24}
            cardProps={{ isBatch, onFeedback, infoHeight: 50 }}
            url="/zhikuan/intelligence-tag/images"
            method="post"
            params={{}}
            afterLoad={data => {
              setBatchAll(data)
              fetchData()
            }}
            empty={<EmptyList />}
            emptySubTitle="你有审核权限的灵感集中提交审核的款式都将展示在此处"
            emptyType="image"
          />
        </div>
        {feedbackModalVisible && <FeedbackModal
          visible={feedbackModalVisible}
          picUrl={feedbackModalData.mainUrl}
          unionId={feedbackModalData.unionId}
          boxLabelRetList={feedbackModalData.boxLabelRetList}
          onOk={onFeedbackModalOk}
          onClose={() => { setFeedbackModalVisible(false) }}
        />}
        {
      infoModalVisible && <InfoModals
        infoModalRef={infoModalRef}
        visible={infoModalVisible}
        onClose={() => {
          setInfoModalVisible(false)
        }}
      />
    }
      </div>
    </div>
  </div>
}

const InfoModals = ({ infoModalRef, ...props }) => {
  return <InfoModal
    ref={infoModalRef}
    {...props}
  />
}

const EmptyList = () => {
  const result = getBoxLabelRetList(emptyJson.boxLabelRetList)
  return <div className="mn-marking-list-empty">
    <div className="empty-content">
      <img src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/ins-selected/1666322620004_cmg6fj17gm.png" />
      <div>
        <RecordInfoCard className="empty-show" boxLabelRetList={result} />
      </div>
    </div>
  </div>
}

const Card = ({
  columnWidth,
  infoHeight = 0,
  mainUrl,
  unionId,
  sourceTime,
  onDeleteItem,
  boxLabelRetList,
  item,
  outerIndex,
  onClickCard,
  total,
  data,
  isBatch,
  source,
  onFeedback, ...props }) => {
  const [visible, setVisible] = useState(false)
  const result = getBoxLabelRetList(boxLabelRetList)

  const categorys = useMemo(() => {
    const _result = result?.map(i => i.category)
    return _result.join('、')
  }, [result])

  const [visibleDetail, setVisibleDetail] = useState(false)
  const [index, setIndex] = useState(outerIndex)

  useEffect(() => {
    setIndex(outerIndex)
  }, [outerIndex])

  const onChangeIndex = (_outerIndex) => {
    setIndex(_outerIndex)
    props.onChangeIndex && props.onChangeIndex(_outerIndex)
  }

  const _onChange = (success, itemParams) => {
    if (success) {
      props.setData((pre) => {
        const i = pre.findIndex(_item => _item.imageGroupEntityId === itemParams?.entityId)
        if (i !== -1) {
          pre[i] = { ...pre[i], ...itemParams }
        } else {
          message.error('错误')
        }
        return [...pre]
      })
      props.onResize()
    }
  }

  const recognizeStatusEnum = {
    0: '识别中...',
    1: categorys,
    2: '识别失败'
  }

  return <div
    className="mn-marking-list-content-wrapper-card"
    style={{
      width: columnWidth,
      height: props.width ? Math.round((columnWidth * props.height) / props.width) + infoHeight : columnWidth,
      display: 'flex',
      flexDirection: 'column'
    }}
  >
    <Popover
      destroyTooltipOnHide={{ keepParent: false }}
      visible={visible}
      onVisibleChange={vis => {
        if (!isBatch) {
          setVisible(vis)
        }
      }}
      placement="rightTop"
      overlayClassName={styles['mn-marking-list-popover']}
      content={<RecordInfoCard
        boxLabelRetList={result}
        onFeedback={() => {
          setVisible(false)
          onFeedback({
            mainUrl,
            unionId,
            boxLabelRetList: result
          })
        }}
      />}
    >
      <div onClick={(e) => {
        e.stopPropagation()
        onClickCard ? onClickCard(data[outerIndex], e) : source === 2 && !isBatch && setVisibleDetail(true)
      }}
      >
        <CardImage
          mainUrl={mainUrl}
          isBatch={isBatch}
          item={item}
          onDeleteItem={onDeleteItem}
          {...props}
        />
      </div>
    </Popover>
    <div className="mn-marking-list-content-wrapper-card-footer">
      <div>{moment(sourceTime).format('YYYY-MM-DD')}</div>
      {
        recognizeStatusEnum[item.recognizeStatus] && <div className={classNames('mn-marking-list-content-wrapper-card-footer-label', { in: !item.recognizeStatus })}>{recognizeStatusEnum[item.recognizeStatus]}</div>
      }
    </div>
    {visibleDetail ? <ImageDetail
      visible={visibleDetail}
      onVisibleChange={(_visible) => { setVisibleDetail(_visible); setIndex(outerIndex) }}
      outerIndex={index}
      listLength={total || data.length}
      onChangeIndex={onChangeIndex}
      blogId={data?.[index].imageGroupEntityId}
      inspirationId={data?.[index].inspirationId}
      collectId={data?.[index].collectId}
      onChange={_onChange}
      onDeleteItem={props.onDeleteItem}
      initWaterfall={props.initWaterfall}
      initSubColls={props.initSubColls}
    /> : null}
  </div>
}

const CardImage = ({ mainUrl, isBatch, onDeleteItem, item, ...props }) => {
  const remote = () => {
    ModalConfirm.show({
      title: '确认删除',
      content: '是否删除当前识别记录？',
      onOk: async () => {
        request.post('/zhikuan/intelligence-tag/delete', { unionIdList: [item.unionId] }).then(success => {
          if (success) {
            message.success('删除成功')
            props.onItemDataChange()
            props.initSubColls && props.initSubColls()
            onDeleteItem(item)
            props.onResize()
          }
        })
      },
    })
  }
  const sourceEnum = {
    1: '上传图片',
    2: '上传款式'
  }

  return <div className="mn-marking-list-content-wrapper-card-image-wrapper">
    <img
      className="mn-marking-list-content-wrapper-card-image"
      src={mainUrl}
    />
    {!isBatch ? <div className="mn-marking-action">
      <Action
        onDeleteItem={() => {
          remote()
        }}
      />
    </div> : <div className="mn-marking-action-batch-mask">
      <BatchItem keyValue={item.unionId} className="batch-check" />
    </div>}
    <div className="mn-marking-source">{sourceEnum[item.source]}</div>
  </div>
}
